var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// TEMP(tmp_hide_new_ai_summary): remove when IP-15683 ships.
// Verbatim copy of the master AiSummaryBanner (written ai_summary from
// /api/internal/ai_summaries). Rendered when ia_ipa_subprocesses_enabled is off
// so those tenants keep the pre-IP-15683 behaviour.
import React, { useState, useEffect } from 'react';
import api from '@utils/api-client';
import { Accordion } from '@ui/molecules/Accordion';
import { translate } from '@utils/i18n';
import AiPlusIcon from './AiPlusIcon';
import './AiSummaryBanner.scss';
const NS = 'features.iim_review.ai_summary_banner';
function LegacyAiSummaryBanner({ inspectionId }) {
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [summary, setSummary] = useState(null);
    useEffect(() => {
        const checkBannerStatus = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield api.get(`/api/internal/ai_summaries?inspection_id=${inspectionId}`);
                const summaryData = response.data[0];
                setIsVisible((summaryData === null || summaryData === void 0 ? void 0 : summaryData.aiSummary) !== null);
                setSummary((summaryData === null || summaryData === void 0 ? void 0 : summaryData.aiSummary) || null);
            }
            catch (error) {
                console.error('Failed to fetch AI summary:', error);
                setIsVisible(false);
                setSummary(null);
            }
            finally {
                setIsLoading(false);
            }
        });
        void checkBannerStatus();
    }, [inspectionId]);
    const hasSummary = !isLoading && isVisible && summary != null && summary.trim() !== '';
    if (!hasSummary)
        return null;
    const title = (React.createElement("span", { className: "ai-summary-banner__title" },
        React.createElement(AiPlusIcon, null),
        translate('title', { namespace: NS })));
    return (React.createElement(Accordion, { title: title, variant: "inline", defaultExpanded: true, className: "ai-summary-banner ai-summary-banner--legacy" },
        React.createElement("div", { className: "ai-summary-banner__body" },
            React.createElement("p", null, summary))));
}
export default LegacyAiSummaryBanner;
